<template>
  <div>
    <div class="pic-btn">
    <el-button type="text" @click="handleUpload"
      ><i class="icon el-icon-upload" />上传素材库</el-button
    >
    </div>
    <div class="pic-box">
      <Upload
        v-if="uploadVisible"
        :visible.sync="uploadVisible"
        :type="tabType"
        :category="[Number(sortId), Number(secondId)]"
        @close="getImgList(1)"
      />
    </div>
  </div>
</template>

<script>
import CardList from "../common/CardList";
import CardListCommon from "../common/CardListCommon";
import Empty from "../common/Empty";
import Upload from "../common/Upload";
import AddClass from "../common/AddClass";
import AddClassScoped from "../common/AddClassScoped";
import Tabs from "../common/Tabs";
import { getSortList, setDefaultSort, getCommonList } from "../common.js";

export default {
  components: {
    CardList,
    CardListCommon,
    Empty,
    Upload,
    AddClass,
    AddClassScoped,
    Tabs
  },
  data() {
    return {
      tabType: "1",
      searchValue: "",
      sortList: [],
      sortId: "",
      secondList: [],
      secondId: "",
      page: {
        currentPage: 0,
        totalCount: 0,
        pageSize: 50,
        disabled: false
      },
      imgList: [],
      uploadVisible: false,
      classVisible: false,
      loading: false
    };
  },
  computed: {
    isEditAndDelete() {
      // 是否有删除和修改的权限
      const authStr = decodeURIComponent(lib.cookie.get("authority") || "");
      const auths = authStr.split(",");
      if (this.tabType === "1") return true;
      return auths.includes("4");
    }
  },
  methods: {
    handleEditClass() {
      if (this.tabType === "1") {
        this.$router.push("/category");
      } else {
        this.$router.push("/categoryCommon");
      }
    },
    async hanldeTab1() {
      this.sortList = await getSortList();
      const sort = setDefaultSort(this.sortList);
      if (sort !== null) {
        this.sortId = String(sort);
      }
      this.getImgList(1);
    },

    async getCommonTab(parent_id) {
      const list = await getCommonList(parent_id);
      const sort = setDefaultSort(list);
      let id = null;
      if (sort !== null) {
        id = sort;
      }
      return {
        list,
        id
      };
    },
    async handleTab2() {
      const { list, id } = await this.getCommonTab();
      this.sortList = list;
      this.sortId = String(id);
      if (this.sortList.length) {
        this.tabClick2(this.sortId);
      }
    },
    async changeTab() {
      this.sortList = [];
      this.secondList = [];
      this.imgList = [];
      if (this.tabType === "1") {
        this.hanldeTab1();
      } else if (this.tabType === "2") {
        this.handleTab2();
      }
    },
    handleAddClass() {
      this.classVisible = true;
    },
    handleUpload() {
      this.uploadVisible = true;
    },
    tabClick1() {
      this.getImgList(1);
    },
    async tabClick2(parent_id) {
      const { list, id } = await this.getCommonTab(parent_id);
      this.secondList = list;
      this.secondId = id;
      this.getImgList(1);
    },
    handleScecondChange(value) {
      this.secondId = value;
      this.getImgList(1);
    },

    async handleSearch() {
      this.loading = true;
      try {
        await this.getImgList(1);
      } catch (error) {}
      this.loading = false;
    },

    handleTagChange() {
      this.imgList = [];
      if (this.tabType === "1") {
        this.tabClick1();
      } else if (this.tabType === "2") {
        this.tabClick2(this.sortId);
      }
    },
    getImgList(num) {
      if (num) {
        this.page.currentPage = num;
      } else {
        this.page.currentPage++;
      }
      if (this.page.currentPage === 1) {
        this.page.disabled = false;
      }
      var params = {};
      let api = "";
      if (this.tabType === "1") {
        api = "api/test/images/list";
        params = {
          count: this.page.pageSize,
          page: this.page.currentPage - 1,
          sort_id: this.sortId,
          name: this.searchValue
        };
      } else if (this.tabType === "2") {
        api = "api/test/material/list";
        params = {
          count: this.page.pageSize,
          page: this.page.currentPage,
          category_id: this.secondId,
          keyword: this.searchValue
        };
        if (
          params.category_id === undefined ||
          params.category_id === "" ||
          params.category_id === null
        ) {
          return;
        }
      }
      return lib.tmsapi.get({
        api,
        data: params,
        success: res => {
          let data = [];
          if (res && res.data && res.data.length) {
            data = res.data;
            this.page.totalCount = res.total;
          }
          if (this.page.currentPage === 1) {
            this.imgList = data;
          } else {
            this.imgList.push(...data);
          }
          if (this.imgList.length >= this.page.totalCount) {
            this.page.disabled = true;
          }
        }
      });
    },
    async getSortListFn() {
      if (this.tabType === "1") {
        this.sortList = await getSortList();
      } else {
        const { list } = await this.getCommonTab();
        this.sortList = list;
      }
    }
  },
  created() {
    this.changeTab();
  }
};
</script>

<style scoped>
.pic-btn{
  display: flex;
  height: 400px;
  align-items: center;
  justify-content: center;
}
.tab-box {
  flex: 1;
  overflow-x: scroll;
}
.tab-box /deep/.el-tabs__nav-wrap::after {
  background-color: transparent;
}
.btn-box {
  flex-shrink: 0;
}
.pic-box {
  height: 100%;
  padding: 16px;
}
.pic-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background: #fff;
  border-radius: 8px 8px 0px 0px;
}
.pic-header-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 54px;
  background: #fff;
  border-radius: 0px 0px 8px 8px;
  border-top: 1px solid #dcdfe6;
  padding: 0 12px 0 36px;
}
.input-btn {
  display: flex;
  margin-right: 36px;
}
.search-input /deep/.el-input-group__append {
  color: #fff;
  background-color: #3e89ff;
}
/deep/.el-tabs__header {
  margin-bottom: 0;
}
/deep/.el-tabs__item {
  height: 52px;
  line-height: 52px;
}
.icon {
  margin-right: 5px;
}
.btn-item {
  padding: 0 24px;
  border-right: 1px solid #f3f5f7;
}
.empty {
  margin-top: 79px;
}
.pic-main {
  height: calc(100% - 122px);
  overflow-y: scroll;
}
.mk-tab {
  padding: 16px 20px;
}
</style>
